import { ReactComponent as IncidentIoIcon } from '@elementary/common-ui/assets/alert-integrations/incident-io.svg';
import { ReactComponent as RootlyIcon } from '@elementary/common-ui/assets/alert-integrations/rootly.svg';
import { ReactComponent as OpsgenieIcon } from '@elementary/common-ui/assets/alert-integrations/opsgenie.svg';
import { ReactComponent as PagerIcon } from '@elementary/common-ui/assets/alert-integrations/pagerduty.svg';
import { ReactComponent as SlackIcon } from '@elementary/common-ui/assets/alert-integrations/slack.svg';
import { ReactComponent as TeamsIcon } from '@elementary/common-ui/assets/alert-integrations/teams.svg';
import { ReactComponent as EmailIcon } from '@elementary/common-ui/assets/16x16/email.svg';
import { IntegrationType } from 'shared/types';

type Props = {
  type: IntegrationType;
  size?: number;
};

const AlertDestinationIcon = ({ type, size = 16 }: Props) => (
  <>
    {type?.toLowerCase() === 'slack' && (
      <SlackIcon height={size} width={size} />
    )}
    {type?.toLowerCase() === 'pager_duty' && (
      <PagerIcon height={size} width={size} />
    )}
    {type?.toLowerCase() === 'microsoft_teams' && (
      <TeamsIcon height={size} width={size} />
    )}
    {type?.toLowerCase() === 'microsoft_teams_bot' && (
      <TeamsIcon height={size} width={size} />
    )}
    {type?.toLowerCase() === 'opsgenie' && (
      <OpsgenieIcon height={size} width={size} />
    )}
    {type?.toLowerCase() === 'incident_io' && (
      <IncidentIoIcon height={size} width={size} />
    )}
    {type?.toLowerCase() === 'rootly' && (
      <RootlyIcon height={size} width={size} />
    )}
    {type.toLowerCase() === 'email' && <EmailIcon height={size} width={size} />}
  </>
);

export default AlertDestinationIcon;
